import React, { FC } from 'react';
import styles from './index.module.less';
import Image from '@base/lib/ThemeImage';
import { ISFSProduct } from 'mod/feature/interface';
import { getActivityStatus, TActivityStatus } from 'base/utils/flashsale';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';

type IProps = {
    imgWrapRef,
    item: ISFSProduct;
    currentTime: number;
}

const ImageMask: FC<{
    status: TActivityStatus
    activityStock: number;
}> = ({ status, activityStock }) => {
    const { t } = useTrans();
    if (status === 'ended') {
        return <div className={cn(styles.mask, 'flex flex-center flex-middle')}>
            {t('web_home_sfs_sale_is_over')}
        </div>
    }
    if (activityStock === 0) {
        return <div className={cn(styles.mask, 'flex flex-center flex-middle')}>
            {t('web_product_sold_out')}
        </div>
    }
    return null;
}

const PicAndMask: React.FC<IProps> = (props) => {

   const {
       imgWrapRef ,
       item: {
           pic,
           previewPic,
           activityStock,
           startTime,
           endTime,
       },
       currentTime,
   } = props

    const status = getActivityStatus(currentTime, startTime, endTime);

    return(
        <div className={cn(styles.picture, 'g-sfs-pic')}>
            <Image
                ref={imgWrapRef}
                src={status === 'notStarted' ? previewPic : pic}
                width={288}
                background={false}
            />
            <ImageMask status={status} activityStock={activityStock}/>
        </div>
    );
};

export default PicAndMask